import { createApp, provide, h } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client/core";
import App from "./App.vue";
import router from './router'
import { setContext } from '@apollo/client/link/context';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';


import { BootstrapVueNext, BModal,
  BBreadcrumb,
  BBreadcrumbItem,
  BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItemDropdown, BDropdownItem, BDropdownDivider,
  BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BBadge,
    BListGroup,
    BListGroupItem,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormCheckbox,
    BFormText,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BSpinner,
    BToast,
} from 'bootstrap-vue-next';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import '@fortawesome/fontawesome-free/css/all.css';
import store from './store/store.js'; // import the store

import { BASE_URL } from '@/config';

//import axios from 'axios';
const cache = new InMemoryCache();

// Use setContext to inject the JWT token into the headers
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('jwt');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  };
});



// Create an HttpLink to your GraphQL endpoint
const httpLink = new HttpLink({
  uri: BASE_URL+'/graphql',
});

const apolloClient = new ApolloClient({
 link: authLink.concat(httpLink),
 cache,
});

const app = createApp({
 setup() {
   provide(DefaultApolloClient, apolloClient);
 },

 render: () => h(App),
}).use(router);


app.use(BootstrapVueNext);

// Register components globally with names
app.component('BModal', BModal);
app.component('BBreadcrumb', BBreadcrumb);
app.component('BBreadcrumbItem', BBreadcrumbItem);
app.component('BNavbar', BNavbar);
app.component('BNavbarNav', BNavbarNav);
app.component('BNavbarBrand', BNavbarBrand);
app.component('BNavbarToggle', BNavbarToggle);
app.component('BCollapse', BCollapse);
app.component('BNavItemDropdown', BNavItemDropdown);
app.component('BDropdownItem', BDropdownItem);
app.component('BDropdownDivider', BDropdownDivider);
app.component('BButton',BButton);
app.component('BCard',BCard);
app.component('BCardBody',BCardBody);
app.component('BCardHeader',BCardHeader);
app.component('BCardTitle',BCardTitle);
app.component('BCardSubTitle',BCardSubTitle);
app.component('BTable',BTable);
app.component('BBadge',BBadge);
app.component('BListGroup',BListGroup);
app.component('BListGroupItem',BListGroupItem);
app.component('BForm',BForm);
app.component('BFormGroup',BFormGroup);
app.component('BFormInput',BFormInput);
app.component('BFormSelect',BFormSelect);
app.component('BFormSelectOption',BFormSelectOption);
app.component('BFormCheckbox',BFormCheckbox);
app.component('BFormText',BFormText);
app.component('BFormInvalidFeedback',BFormInvalidFeedback);
app.component('BRow',BRow);
app.component('BCol',BCol);
app.component('BSpinner',BSpinner);
app.component('BToast',BToast);

app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
});

app.use(store); // use the store
app.mount("#app");
